<template>
  <div class="stcfgl">
    <header>
<!--      <section class="bjt">
        <img src="../assets/img/dingbu1.png" class="left" alt=""/>
        <div class="center"></div>
        <img src="../assets/img/dingbu3.png" class="right" alt=""/>
      </section>-->
      <img src="../assets/img/01logo1.png" class="logo-img" alt=""/>
      <span class="title">{{ sysName }}</span>
      <div class="user-Name">
<!--        <span class="userInfo">{{userName}}{{dwmc?'（'+dwmc+'）':''}}</span>
        <img src="../assets/img/tuichu.png" alt="" @click="exitbtn()" />-->
<!--        <el-avatar :size="34" style="margin-right: 10px">
          <img  src="../assets/img/default_avatar.png" alt=""/>
        </el-avatar>-->
        <el-dropdown :hide-on-click="false">
          <span class="el-dropdown-link userInfo">
            {{userName}}{{dwmc?'（'+dwmc+'）':''}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="xgmmClk()">设置密码</el-dropdown-item>
            <el-dropdown-item divided @click.native="exitbtn()">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </header>
    <div class="nr">
      <div class="navList">
        <el-menu
            :default-active="defaultActive"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            background-color="transparent"
            text-color="#fff"
            active-text-color="#fff">
            <!-- active-text-color="#ffd04b"> -->
          <div v-for="(item,index) in menuList" :key="index">
            <el-submenu :index="String(index)" v-if="item.sysMenuList.length>0" class="custom-submenu">
              <template slot="title">
                <div class="menu-item-content">
<!--                  <img :src="require(`@/assets/${item.menuIcon}`)" alt="菜单图标"/>-->
                  <i :class="item.menuIcon"></i>
                  <span class="menu-title">{{ item.menuName }}</span>
                </div>
              </template>
              <el-menu-item-group v-for="(item2,index2) in item.sysMenuList" :key="index2">
                <el-menu-item :index="`${index}-${index2}`" @click="toRouter(item2)" class="submenu-item">
                  <i :class="item2.menuIcon"></i>
                  <el-badge v-if="item2.menuUrl=='xmspdbList'" :value="myTodoList.length" class="item">
                    {{ item2.menuName }}
                  </el-badge>
                  <span v-else>{{ item2.menuName }}</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-menu-item :index="String(index)" v-if="item.sysMenuList.length==0" @click="toRouter(item)" class="menu-item-single">
              <div class="menu-item-content">
<!--                <img :src="require(`@/assets/${item.menuIcon}`)" alt="菜单图标" class="menu-icon"/>-->
                <i :class="item.menuIcon" style="color: #FFFFFF"></i>
                <span class="menu-title">{{ item.menuName }}</span>
              </div>
            </el-menu-item>
          </div>
        </el-menu>
      </div>
      <div class="content">
        <div class="tsxx">
          <div class="left">
            <span></span>
            {{ titleName }}
          </div>
        </div>
        <div class="content2">
          <router-view :key="$route.fullPath" />
        </div>
      </div>
    </div>

    <!-- 修改密码 -->
    <el-dialog title="设置密码" :close-on-click-modal="false" :visible.sync="dialogEditPwdForm">
      <div class="newpassword" style="margin-bottom: 10px">
        <label style="margin-left: 28px">新密码:</label>
        <el-input style="display: inline-block;width: 80%" v-model="newpassword" type="password" show-password :placeholder="pwdTipe"></el-input>
      </div>
      <div class="repassword">
        <label>新密码确认:</label>
        <el-input style="display: inline-block;width: 80%" v-model="repassword" type="password" show-password :placeholder="'新'+pwdTipe"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogEditPwdForm = false">取 消</el-button>
        <el-button type="primary" @click="eidtPassword()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sysName: '',
      userId: '',//用户id
      userName: '',//用户名称
      menuList: [],//菜单列表
      titleName: '',
      dwmc: '',//单位名称
      defaultActive: '', // 新增默认激活状态

      dialogEditPwdForm: false,
      newpassword: '',//新密码
      repassword: '',//确认密码
      passwordRule: '^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>|\[\]\\\/?])[\S\s]{8,16}$',
      pwdTipe: '密码应由8到16位且包含大小写字母、特殊符号和数字组成',
    };
  },
  watch: {
    $route:{
      handler(val){
        this.menuList.forEach(item=>{
          if(val.path.indexOf(item.path)>-1){
            this.titleName = item.label;
          }
        })
      },
      deep: true,
    },
  },
  created() {
    this.getSysName();
  },
  mounted() {
    var access_token = sessionStorage.getItem("access_token");
    if(access_token==""||access_token==null||access_token==undefined||access_token=="undefined"){//若token为空则是登录
      this.$router.push({path: '/pcLogin'});
    }else{
      this.$router.push({path: '/'});
      this.findUserInfo();//获取用户信息
    }
  },
  methods: {
    //获取系统名称
    getSysName(){
      this.$post('sys/findSysConfigByConfigKey',{configKey: "system_name"}).then((arg) => {
        var title = arg.result.sysConfig.configValue;
        this.sysName = title;
        document.title=title;
      })
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    toRouter(item){
      this.titleName = item.menuName;
      this.$router.push({path: item.menuUrl});
    },
    //获取用户菜单权限
    getYongHuMenuList(){
      this.menuList = [];
      var roleType = sessionStorage.getItem("roleType");
      var params = {roleType: roleType,  menuType: "web"};
      this.$post('user/yonghuMenuList', params).then((arg) => {
        /*var yonghumenuList = arg.result.yonghumenuList;
        for(var i=0;i<yonghumenuList.length;i++){
          if(yonghumenuList[i].menuType === "web"){
            this.menuList.push({path: yonghumenuList[i].menuUrl,icon: yonghumenuList[i].menuIcon,label: yonghumenuList[i].menuName});
          }
        }*/
        this.menuList= arg.result.yonghumenuList;
        //判断第一个菜单是否有子菜单，若有则默认跳转到第一个子菜单，并且展开选中第一个子菜单，否则直接跳转第一个菜单
        if(this.menuList.length>0){
          // 设置默认激活菜单项
          this.defaultActive = '0' // 初始化第一个主菜单
          if(this.menuList[0].sysMenuList.length>0){
            this.$router.push({path: this.menuList[0].sysMenuList[0].menuUrl});
            this.titleName = this.menuList[0].sysMenuList[0].menuName;
            this.defaultActive = '0-0'; // 设置子菜单激活状态
          }else{
            this.$router.push({path: this.menuList[0].menuUrl});
            this.titleName = this.menuList[0].menuName;
          }
        }
      })
    },
    findUserInfo(){
      this.$post('user/findUserInfo').then((arg) => {
        var userInfo = arg.result.userInfo;
        this.userName = userInfo.userName;
        this.userId = userInfo.userId;
        sessionStorage.setItem("userName", userInfo.userName);
        sessionStorage.setItem("sjh", userInfo.userLoginName);
        sessionStorage.setItem("roleType", userInfo.userType);
        sessionStorage.setItem("jgglId", userInfo.jgglId);
        sessionStorage.setItem("dlsglId", userInfo.dlsglId);
        this.getYongHuMenuList();
        this.getConfigInfo();
      })
    },
    exitbtn(){
      this.$confirm('此操作将退出系统, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("roleType");
        this.$router.push({path: '/pcLogin'});
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        });
      });
    },
    //获取系统配置信息
    getConfigInfo(){
      this.$post('sys/findSysConfigByConfigKey',{configKey: "password_rule"}).then((arg) => {
        this.passwordRule = arg.result.sysConfig.configValue;
        this.pwdTipe = arg.result.sysConfig.configDes;
      })
    },
    // 修改密码
    xgmmClk() {
      this.newpassword = '';
      this.repassword = '';
      this.dialogEditPwdForm = true;
    },
    //修改密码
    eidtPassword(){
      if(this.newpassword==""){
        this.$message({
          type: "error",
          message: "请输入新密码"
        });
        return;
      }else{
        var checkPwd = this.checkPwd(this.newpassword,this.passwordRule);
        if(!checkPwd){
          this.$message({
            type: "error",
            message: "新"+this.pwdTipe
          });
          return;
        }
      }
      if(this.repassword==""){
        this.$message({
          type: "error",
          message: "请输入确认密码"
        });
        return;
      }else{
        var checkPwd = this.checkPwd(this.repassword,this.passwordRule);
        if(!checkPwd){
          this.$message({
            type: "error",
            message: "确认"+this.pwdTipe
          });
          return;
        }else{
          if(this.newpassword!=this.repassword){
            this.$message({
              type: "error",
              message: "两次密码不一致"
            });
            return;
          }
        }
      }
      var _this = this;
      var params = {
        "userId":this.userId,
        "newPassword":this.newpassword
      };
      _this.$post("user/eidtPassword",params).then(function(response) {
        if (response.result == "1") {
          _this.$message({
            type: "success",
            message: response.message
          });
          _this.dialogEditPwdForm = false;
        } else {
          _this.$message({
            type: "error",
            message: response.message
          });
        }
      }).catch(function(error) {
        // console.error(err);
      });
    },
  }
};
</script>

<style>
.el-submenu__title i {
  color: #ffffff!important;
}
.el-badge__content.is-fixed {
  top: 12px!important;
  right: 5px!important;
}
</style>
<style lang="less" scoped>
.stcfgl {
  min-height: 60vh;
  background-color: #F2F2F2;

  header {
    background: #559cf4;
    height: 50px;
    //display: flex;
    align-items: center;
    // background: #FD5F3B;
    padding-left: 18px;
    line-height: 50px;
    position: relative;

    .el-dropdown-link {
      cursor: pointer;
      color: #409EFF;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
    .bjt{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: space-between;
      .left{
        height: 100%;
      }
      .center{
        width: 100%;
        height: 100%;
        background: url(../assets/img/dingbu2.png);
        background-size: 100% 100%;
        margin-left: 0;
      }
      .right{
        height: 100%;
      }
    }
    .logo-img{
      width: 30px;
      height: 30px;
      margin-right: 10px;
      vertical-align: middle;
      margin-top: -5px;
    }
    .title {
      font-weight: 500;
      font-size: 20px;
      color: #FFFFFF;
      position: relative;
      z-index: 99;
      letter-spacing: 2px;
      //text-shadow: -2px -2px 0 #125B98, 2px -2px 0 #125B98, -2px 2px 0 #125B98, 2px 2px 0 #125B98;
    }
    .user-Name{
      float: right;
      position: relative;
      z-index: 99;
      display: flex;
      align-items: center;
      //padding-right: 40px;
      .el-dropdown{
        height: 45px;
        margin-right: 36px;
      }
      img{
        height: 21px;
        margin-left: 50px;
      }
      .userInfo {
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
      }
    }
  }

  .nr {
    display: flex;

    .navList {
      width: 200px;
      height: calc(100vh - 50px);
      overflow-y: auto;
      scrollbar-width: none;
      flex-shrink: 0;
      //background: url(../assets/img/zuoce.png);
      background-size: 100% 100%;
      background: linear-gradient(18deg, #90CAFA, #559cf4);

      a {
        height: 57px;
        cursor: pointer;
        font-size: 16px;
        color: #FFFFFF;
        font-weight: 400;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        p{
          display: flex;
          align-items: center;
          width: 100%;
          padding-left: 30px;
          img{
            width: 22px;
            margin-right: 12px;
          }
        }
      }
      .router-link-exact-active{
        background-color: rgba(255,255,255,.3);
        font-weight: 500;
        span{
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 6px;
          height: 100%;
          background: #FFFFFF;
          border-radius: 0px;
        }
      }

      .el-menu {
        border-right: 0;

        .menu-item-content {
          display: flex;
          align-items: center;
          padding-left: 0;

          img {
            width: 22px;
            margin-right: 12px;
          }

          .menu-title {
            font-size: 16px;
          }
        }

        .el-submenu__title, .el-menu-item {
          height: 50px;
          line-height: 50px;
          &:hover {
            background-color: rgba(255,255,255,0.2) !important;
          }
        }
        .submenu-item {
          padding-left: 40px !important;
          i {
            color: #ffffff;
          }
          .submenu-icon {
            width: 18px;
            margin-right: 10px;
          }
        }

        .el-menu-item.is-active {
          background-color: rgba(255,255,255,0.3) !important;
          position: relative;
          font-weight: 500 !important;
          padding-left: 0;
          i {
            // color: rgb(255, 208, 75);
          }
          &::before {
            content: "";
            position: absolute;
            left: max(1px);
            top: 0;
            bottom: 0;
            width: 4px;
            background: #fff;
          }
        }
      }
    }

    .content {
      width: calc(100% - 260px);
      height: calc(100vh - 80px);
      margin: 15px 30px 0;

      .tsxx {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 30px;

        .left {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: 500;
          font-size: 20px;
          color: #454545;
          span {
            display: inline-block;
            width: 6px;
            height: 26px;
            background: linear-gradient(0deg, #559cf4 0%, #90CAFA 100%);
            border-radius: 3px;
            margin-right: 13px;
            margin-top: 3px;
          }
        }
      }

      .content2 {
        margin-top: 10px;
        background-color: #FFFFFF;
        padding: 20px;
        // min-height: calc(100% - 40px);
        height: calc(100% - 40px);
        border-radius: 8px;
        overflow-y: auto;
      }
    }
  }
}
</style>